import { render, staticRenderFns } from "./TaskNotificationModal.vue?vue&type=template&id=6b4eb358&"
import script from "./TaskNotificationModal.vue?vue&type=script&lang=js&"
export * from "./TaskNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports